import styles from "./KRS_SinglePreviewFromEditState.module.css";
import { JAPANESE_REGEX } from "../../../constants";
import { useState } from "react";
const SinglePreviewFromEditState = ({ state, preview }) => {
  console.log("Inside SinglePreviewFROM EDIT STATE");
  console.log(state);
  console.log(preview);
  return (
    <div className={styles.preview_section}>
      <div className={styles.white_border_01}></div>
      <div className={styles.white_border_02}></div>
      <div className={styles.white_border_03}></div>
      <div className={styles.white_border_04}></div>
      <div className={styles.white_border_05}></div>

      <img
        className={styles.preview_image}
        src={preview ? URL.createObjectURL(preview) : ""}
        alt="alt img"
        style={{
          width: "980px",
          height: "auto",
          maxWidth: "100%",
        }}
      />
    </div>
  );
};

export default SinglePreviewFromEditState;
